import classnames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { SEARCH_CONTENT_ID } from "@components/Search/SearchResults/StateComponents/NumberOfHits/numberOfHits.container";
import { ContentPagination } from "@components/Search/SearchResults/StateComponents/Pagination/paginationComponents";
import { ContentResultList } from "@components/Search/SearchResults/StateComponents/ResultList/resultListComponents";

type ContentSearchResultsComponentProps = {
    expanded: boolean;
};

const ContentSearchResultsComponent = ({
    expanded,
}: ContentSearchResultsComponentProps) => {
    const { t } = useGranite();

    return (
        <article
            id={SEARCH_CONTENT_ID}
            className={classnames(
                "search__content",
                expanded && "search__content--expanded",
            )}
        >
            <h3>{t("search.results.title.contentPages")}</h3>
            <ContentResultList />
            <ContentPagination />
        </article>
    );
};

export { ContentSearchResultsComponent };
